module.exports = __webpack_public_path__ + "static/media/1920x433.648cb7ae.jpg";